import React, { useEffect, useState } from "react";
import {
  PowderAutomizationData,
  VolumePartReductionData,
  Co2ePowderScenarioMData,
  GreenEnergyMixData,
  InertGasReductionSMData,
  Co2TotalTodaySMData,
  Co2TotalTomorrowSMData,
  PowderAutomizationInput,
  VolumePartReductionInput,
  GreenEnergyMixInput,
  TotalTraspotation,
} from "atoms/Co2Metal/ScenarioMetal";
import { useRecoilState } from "recoil";
import {
  CO2eModeOfTranspotation1,
  CO2eModeOfTranspotation2,
  CO2eModeOfTransportNode1,
  CO2eModeOfTransportNode2,
  CO2eEnergySMData,
} from "atoms/Co2Metal/ScenarioMetal";
import { useRoundOffValue } from "app/components/hooks/useRoundOffValue";
import SelectDropdown from "app/components/SelectDropdown";
import { PercentageData, YesNoData, LogisticsData } from "utils/selectDropdowns";
import { DebounceInput } from "react-debounce-input";
import OverrideAbleTip from "app/components/ProductionScenario/OverrideAbleTip";
import TooltipTrippy from "app/components/ProductionScenario/TooltipTrippy";
import { systemPowederLogistics, PowederLogistics } from "app/view/Constant/TooltipText";
import { handleKeyPress } from "utils/validations";

const { getComputedValue } = useRoundOffValue();

const MaterialTableValuesNew = ({ socket, fieldObj, isBold = false }) => {
  const [powderAutomization, setPowderAutomization] = useRecoilState(
    PowderAutomizationData
  );
  const [volumePartReduction, setVolumePartReduction] = useRecoilState(
    VolumePartReductionData
  );
  const [co2ePowder, setCo2EPowder] = useRecoilState(Co2ePowderScenarioMData);
  const [greenEnergyMix, setGreenEnergyMix] = useRecoilState(GreenEnergyMixData);
  const [inertGasReduction, setInertGasReduction] = useRecoilState(
    InertGasReductionSMData
  );
  const [co2eEnergyTotal, setCo2eEnergyTotal] = useRecoilState(CO2eEnergySMData);
  const [co2TotalToday, setCo2TotalToday] = useRecoilState(Co2TotalTodaySMData);
  const [co2TotalTomorrow, setCo2TotalTomorrow] = useRecoilState(
    Co2TotalTomorrowSMData
  );
  const [totalTranpotation, setTotalTraspotation] =
    useRecoilState(TotalTraspotation);

  const co2EmissionPowder = fieldObj?.co2EmissionPowder;
  const Co2ePerPartPM = fieldObj?.Co2ePerPartPM;
  const co2eEmissionFactor = fieldObj?.co2eEmissionFactor;
  const noOfPartsData = fieldObj?.costData?.no_of_parts?.value;
  const partVolume = fieldObj?.costData?.part_volume?.value;
  const partSupportVolume = fieldObj?.costData?.part_support_volume?.value;
  const materialId = fieldObj?.material_id;
  const co2EmissionBuildProcess = fieldObj?.co2EmissionBuildProcess;
  const co2EmissionGas = fieldObj?.co2EmissionGas;
  const inertGasReduction_tomorrow = fieldObj?.inertGasReduction_tomorrow;

  // mode of transportation
  const [modeOfTranspotation1, setModeOfTranspotation1] = useRecoilState(
    CO2eModeOfTranspotation1
  );
  const [modeOfTranspotation2, setModeOfTranspotation2] = useRecoilState(
    CO2eModeOfTranspotation2
  );
  const [modeOfTransportnode1, setmodeOfTransportnode1] = useRecoilState(
    CO2eModeOfTransportNode1
  );
  const [modeOfTransportnode2, setmodeOfTransportnode2] = useRecoilState(
    CO2eModeOfTransportNode2
  );

  const materialTransportaion = fieldObj?.materialTransportaion;
  const systemTransportation = fieldObj?.systemTransportation;
  const cefnone = fieldObj?.cefnone;
  const cefnTwo = fieldObj?.cefnTwo;
  const build_time = fieldObj?.build_time;

  const [powderAtomizationState, setPowderAutomizationState] = useRecoilState(
    PowderAutomizationInput
  );
  const [volumerPartReductionState, setVolumePartReductionState] =
    useRecoilState(VolumePartReductionInput);
  const [greenEnergymixState, setGreenEnergyMixState] = useRecoilState(
    GreenEnergyMixInput
  );
  const [checkInertGasReduction, setCheckInertGasReduction] = useState(
    undefined
  );

  useEffect(() => {
    if (fieldObj) {
      setPowderAutomizationState(fieldObj?.powderAutomizationInput);
      setVolumePartReductionState(fieldObj?.volumePartReductionInput);
      setGreenEnergyMixState(fieldObj?.greenEnergyMixInput);
      setModeOfTranspotation1(fieldObj?.modeOfTranspotation1Input);
      setModeOfTranspotation2(fieldObj?.modeOfTranspotation2Input);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldObj]);

  useEffect(() => {
    if (
      modeOfTranspotation1 &&
      modeOfTranspotation1 !== "undefined" &&
      modeOfTranspotation2 &&
      modeOfTranspotation2 !== "undefined"
    ) {
      socket.off("*");

      socket.emit("carbon-calculator", {
        key: "MSA-MCT",
        input: {
          node1_mode: modeOfTranspotation1,
          node2_mode: modeOfTranspotation2,
          material_transportation: parseInt(materialTransportaion),
          system_transportation: parseInt(systemTransportation),
          carbon_emission_factor_node_1: +cefnone,
          carbon_emission_factor_node_2: +cefnTwo,
          build_time: +build_time,
        },
      });

      socket.on("MSA-MCT", function (data) {
        const transportNode1Today = getComputedValue(
          data?.data?.transport_node_1_today
        );
        const transportNode1Tomorrow = getComputedValue(
          data?.data?.transport_node_1_tomorrow
        );
        const transportNode2Today = getComputedValue(
          data?.data?.transport_node_2_today
        );
        const transportNode2Tomorrow = getComputedValue(
          data?.data?.transport_node_2_tomorrow
        );

        setmodeOfTransportnode1({
          today: transportNode1Today,
          tomorrow: transportNode1Tomorrow,
        });
        setmodeOfTransportnode2({
          today: transportNode2Today,
          tomorrow: transportNode2Tomorrow,
        });
        setTotalTraspotation({
          today: getComputedValue(data?.data?.transport_today),
          tomorrow: getComputedValue(data?.data?.transport_tomorrow),
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modeOfTranspotation1, modeOfTranspotation2]);

  useEffect(() => {
    if (powderAtomizationState && volumerPartReductionState) {
      socket.emit("carbon-calculator", {
        key: "MSA-MCP",
        input: {
          atomizedType: powderAtomizationState,
          co2_emission_powder: parseFloat(co2EmissionPowder),
          reduction_in_volume: parseFloat(volumerPartReductionState),
          powder_energy_per_part: parseFloat(Co2ePerPartPM),
          co2_emission_factor: parseFloat(co2eEmissionFactor),
          no_of_parts: parseFloat(noOfPartsData),
          part_volume: parseFloat(partVolume),
          part_support_volume: parseFloat(partSupportVolume),
          material_id: parseFloat(materialId),
        },
      });

      socket.on("MSA-MCP", function (data) {
        const valuepatod = getComputedValue(
          data?.data?.powder_atomization_today
        );
        const valuepatom = getComputedValue(
          data?.data?.powder_atomization_tomorrow
        );
        const valuecptod = getComputedValue(data?.data?.co2e_powder_today);
        const valuecptom = getComputedValue(data?.data?.co2e_powder_tomorrow);
        const valuevptod = getComputedValue(
          data?.data?.volume_of_the_part_reduction_today
        );
        const valuevptom = getComputedValue(
          data?.data?.volume_of_the_part_reduction_tomorrow
        );
        setPowderAutomization({ today: valuepatod, tomorrow: valuepatom });
        setCo2EPowder({ today: valuecptod, tomorrow: valuecptom });
        setVolumePartReduction({ today: valuevptod, tomorrow: valuevptom });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [powderAtomizationState, volumerPartReductionState]);

  useEffect(() => {
    if (greenEnergymixState) {
      socket.emit("carbon-calculator", {
        key: "MSA-MCE",
        input: {
          isGreenEnergyMix: greenEnergymixState,
          co2_emission_build_process: co2EmissionBuildProcess,
        },
      });

      socket.on("MSA-MCE", function (data) {
        const valuepatod = getComputedValue(data.data.green_energy_mix_today);
        const valuepatom = getComputedValue(
          data.data.green_energy_mix_tomorrow
        );
        setGreenEnergyMix({ today: valuepatod, tomorrow: valuepatom });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [greenEnergymixState]);

  useEffect(() => {
    if (co2EmissionGas && inertGasReduction?.tomorrow?.edited === false) {
      socket.emit("carbon-calculator", {
        key: "MSA-MCG",
        input: { co2_emission_gas: co2EmissionGas },
      });

      socket.on("MSA-MCG", function (data) {
        if (checkInertGasReduction === undefined) {
          setCheckInertGasReduction(true);
        }
        const valuepatod = getComputedValue(
          data.data.inert_gas_reduction_today
        );
        const valuepatom = getComputedValue(
          data.data.inert_gas_reduction_tomorrow
        );
        setInertGasReduction({
          today: valuepatod,
          tomorrow: { value: valuepatom },
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inertGasReduction?.tomorrow?.edited]);

  useEffect(() => {
    if (inertGasReduction_tomorrow?.edited && checkInertGasReduction) {
      setInertGasReduction((prevState) => {
        return {
          ...prevState,
          tomorrow: { value: inertGasReduction_tomorrow?.value, edited: true },
        };
      });
      setCheckInertGasReduction(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inertGasReduction_tomorrow, checkInertGasReduction]);

  useEffect(() => {
    if (
      co2ePowder &&
      co2ePowder.today &&
      greenEnergyMix &&
      greenEnergyMix.today &&
      inertGasReduction &&
      inertGasReduction.today &&
      totalTranpotation &&
      totalTranpotation.today
    ) {
      const value =
        parseFloat(co2ePowder.today) +
        parseFloat(inertGasReduction.today) +
        parseFloat(greenEnergyMix.today) +
        parseFloat(totalTranpotation.today);
      const value1 = getComputedValue(value);
      setCo2TotalToday(value1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    co2ePowder,
    powderAutomization,
    inertGasReduction,
    volumePartReduction,
    greenEnergyMix,
    totalTranpotation,
  ]);
  useEffect(() => {
    if (
      co2ePowder &&
      co2ePowder.tomorrow &&
      greenEnergyMix &&
      greenEnergyMix.tomorrow &&
      inertGasReduction &&
      inertGasReduction.tomorrow &&
      inertGasReduction.tomorrow?.value &&
      totalTranpotation &&
      totalTranpotation.tomorrow
    ) {
      const value =
        parseFloat(co2ePowder.tomorrow) +
        parseFloat(inertGasReduction.tomorrow?.value) +
        parseFloat(greenEnergyMix.tomorrow) +
        parseFloat(totalTranpotation.tomorrow);
      const value1 = getComputedValue(value);

      setCo2TotalTomorrow(value1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    co2ePowder,
    powderAutomization,
    inertGasReduction,
    volumePartReduction,
    greenEnergyMix,
    totalTranpotation,
  ]);

  useEffect(() => {
    if (greenEnergyMix !== undefined && inertGasReduction !== undefined) {
      const value =
        parseFloat(inertGasReduction.today) + parseFloat(greenEnergyMix.today);
      const value1 =
        parseFloat(inertGasReduction.tomorrow?.value) +
        parseFloat(greenEnergyMix.tomorrow);
      const valueCo2EnergyToday = getComputedValue(value);
      const valueCo2EnergyTomorrow = getComputedValue(value1);

      setCo2eEnergyTotal({
        today: valueCo2EnergyToday,
        tomorrow: greenEnergymixState === "yes" ? 0 : valueCo2EnergyTomorrow,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inertGasReduction, greenEnergyMix]);

  return (
    <div className="d-flex flex-column gap-16">
      {/* CO2e Powder */}
      <div className="d-flex flex-column scenario_container">
        <div className="d-flex gap-40 mb-24">
          <span className=" scenario_header">CO2e Powder</span>
          <div className=" scenario_header">Input</div>
          <div className=" scenario_header"> Current Scenario</div>
          <div className=" scenario_header">Future Scenario</div>
        </div>
        {/* Volume Reduction */}
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">
            How much volume reduction in % is possible with redesign?
          </span>
          <div className=" scenario_cell select_wrapper">
            <SelectDropdown
              setState={setVolumePartReductionState}
              getState={volumerPartReductionState}
              Dataset={PercentageData}
              styleclass="dropdown-input_select select_wrapper_text"
            />
          </div>
          <div className={
            "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            {volumePartReduction ? volumePartReduction.today : "_ _ _ _"}
          </div>
          <div className={
            "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            {volumePartReduction ? volumePartReduction.tomorrow : "_ _ _ _"}
          </div>
        </div>
        {/* Total Powder */}
        <div className="d-flex gap-40 font-14 font-weight-bold">
          <span className="scenario_cell font-14 font-weight-bold">
            CO2e Powder (kg)
          </span>
          <div className={
            " font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            &nbsp;
          </div>
          <div className="  scenario_cell ">
            {co2ePowder ? co2ePowder.today : "_ _ _ _"}
          </div>
          <div className="  scenario_cell">
            {co2ePowder ? co2ePowder.tomorrow : "_ _ _ _"}
          </div>
        </div>
      </div>

      {/* CO2e Energy */}
      <div className="d-flex flex-column scenario_container">
        <div className="d-flex gap-40 mb-24">
          <span className=" scenario_header">CO2e Energy</span>
          <div className=" scenario_header">Input</div>
          <div className=" scenario_header"> Current Scenario</div>
          <div className=" scenario_header">Future Scenario</div>
        </div>
        {/* Green Energy Mix */}
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">
            Is there a possibility to switch to a green energy mix?
          </span>
          <div className=" scenario_cell select_wrapper">
            <SelectDropdown
              setState={setGreenEnergyMixState}
              getState={greenEnergymixState}
              Dataset={YesNoData}
              styleclass="dropdown-input_select select_wrapper_text"
            />
          </div>
          <div className={
            "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            {greenEnergyMix ? greenEnergyMix.today : "_ _ _ _ "}
          </div>
          <div className={
            "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            {greenEnergyMix ? greenEnergyMix.tomorrow : "_ _ _ _ "}
          </div>
        </div>
        {/* Inert Gas Reduction override */}
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">How much can you reduce inert gas consumption for your process?</span>
          <div className=" scenario_cell select_wrapper">
            <div className="input-section">
              <DebounceInput
                type="number"
                className=" color-blue font-14 font-semi-bold"

                // className="user-input"
                debounceTimeout={500}
                onChange={(e) => {
                  setInertGasReduction((prevState) => {
                    return {
                      ...prevState,
                      tomorrow: { value: +e.target.value, edited: true },
                    };
                  });
                }}
                onWheel={(e) => e.target.blur()}
                onKeyDown={(e) => handleKeyPress(e)}
                placeholder=""
                value={inertGasReduction?.tomorrow?.value}
              />
             
              {/* <OverrideAbleTip /> */}
            </div>
          </div>
          <div className={
            "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            {inertGasReduction ? inertGasReduction.today : "_ _ _ _"}
          </div>
          <div className={
            "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            {inertGasReduction ? getComputedValue(inertGasReduction.tomorrow?.value) : "_ _ _ _"}
          </div>
        </div>
        {/* Total Energy */}
        <div className="d-flex gap-40 font-14 font-weight-bold">
          <span className="scenario_cell font-14 font-weight-bold">
            CO2e Energy (kg)
          </span>
          <div className={
            " font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            &nbsp;
          </div>
          <div className="  scenario_cell ">
            {co2eEnergyTotal ? co2eEnergyTotal.today : "_ _ _ _"}
          </div>
          <div className="  scenario_cell">
            {co2eEnergyTotal ? co2eEnergyTotal.tomorrow : "_ _ _ _"}
          </div>
        </div>
      </div>

      {/* CO2e Logistics */}
      <div className="d-flex flex-column scenario_container">
        <div className="d-flex gap-40 mb-24">
          <span className=" scenario_header">CO2e Logistics</span>
          <div className=" scenario_header">Input</div>
          <div className=" scenario_header"> Current Scenario</div>
          <div className=" scenario_header">Future Scenario</div>
        </div>
        {/* Node 1 */}
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">
            <TooltipTrippy
              tooltipMessage={systemPowederLogistics}
              fieldName="Change the mode of logistics (node 1)"
            />
          </span>
          <div className=" scenario_cell select_wrapper">
            <SelectDropdown
              setState={setModeOfTranspotation1}
              getState={modeOfTranspotation1}
              Dataset={LogisticsData}
              styleclass="dropdown-input_select select_wrapper_text"
            />
          </div>
          <div className={
            "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            {modeOfTransportnode1 !== undefined
              ? modeOfTransportnode1.today
              : "_ _ _ _"}
          </div>
          <div className={
            "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            {modeOfTransportnode1 !== undefined
              ? modeOfTransportnode1.tomorrow
              : "_ _ _ _"}
          </div>
        </div>
        {/* Node 2 */}
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">
            <TooltipTrippy
              tooltipMessage={PowederLogistics}
              fieldName="Change the mode of logistics (node 2)"
            />
          </span>
          <div className=" scenario_cell select_wrapper">
            <SelectDropdown
              setState={setModeOfTranspotation2}
              getState={modeOfTranspotation2}
              Dataset={LogisticsData}
              styleclass="dropdown-input_select select_wrapper_text"
            />
          </div>
          <div className={
            "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            {modeOfTransportnode2 !== undefined
              ? modeOfTransportnode2.today
              : "_ _ _ _"}
          </div>
          <div className={
            "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            {modeOfTransportnode2 !== undefined
              ? modeOfTransportnode2.tomorrow
              : "_ _ _ _"}
          </div>
        </div>
        {/* Total Logistics */}
        <div className="d-flex gap-40 font-14 font-weight-bold">
          <span className="scenario_cell font-14 font-weight-bold">
            CO2e Logistics (kg)
          </span>
          <div className={
            " font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
          }>
            &nbsp;
          </div>
          <div className="  scenario_cell ">
            {totalTranpotation ? totalTranpotation.today : "_ _ _ _ "}
          </div>
          <div className="  scenario_cell">
            {totalTranpotation ? totalTranpotation.tomorrow : "_ _ _ _ "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaterialTableValuesNew;


